










import FullCalendar from '@fullcalendar/vue';
import { CalendarApi, CalendarOptions, DatesSetArg } from '@fullcalendar/core';
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import { ResourceApi } from '@fullcalendar/resource';
import ContactAvatar from '../contacts/ContactAvatar.vue';
import CalendarViewEvent from '../calendar/CalendarViewTimelineViewEvent.vue';

export default {
  components: { CalendarViewEvent, ContactAvatar, FullCalendar },
  props: {
    resources: { type: Array, required: true },
    eventSources: { type: Function, required: true },
  },
  emits: ['datesSet'],
  computed: {
    options(): CalendarOptions {
      return {
        schedulerLicenseKey: process.env.VUE_APP_FULLCALENDAR_LICENSE_KEY,
        locale: 'da',
        initialView: 'resourceTimeGridDay',
        plugins: [resourceTimeGridPlugin],
        nowIndicator: true,
        nowIndicatorContent: '',
        weekends: true,
        weekNumbers: false,
        allDayText: '',
        titleFormat: { month: 'long', day: '2-digit', year: 'numeric' },
        slotLabelFormat: { hour: '2-digit', minute: '2-digit' },
        slotEventOverlap: false,
        slotMinWidth: 30,
        dayMaxEvents: 2,
        moreLinkText: this.$t('button.more'),
        dayHeaderFormat: { month: 'long', day: '2-digit', year: 'numeric' },
        buttonText: { today: this.$t('calendar.today') },
        headerToolbar: {
          left: 'today title prev,next',
          end: '',
        },
        slotMinTime: '08:00:00',
        slotMaxTime: '18:00:00',
        contentHeight: 'auto',
        resources: this.resources,
        eventSources: this.eventSources,
        datesSet: this.emitDatesSet,
      };
    },
  },
  methods: {
    getApi(): CalendarApi {
      return this.$refs.calendar.getApi();
    },
    getAvatarProfileFromResource(resource: ResourceApi) {
      return { ...resource.extendedProps, id: parseInt(resource.extendedProps.singleId) };
    },
    emitDatesSet(dateInfo: DatesSetArg) {
      this.$emit('datesSet', dateInfo);
    },
  },
};
